export default __webpack_public_path__ + "static/media/pic2.df12fe60.jpg";